<template>
  <div class="experience--detail-box" :style="{left: position === 'left' ? '538px' : '50px' }" @click.stop>
    <template v-if="hasTime && 
    (data.stats_tags && data.stats_from && data.stats_to && data.stats_employee_schools && !notPerson)
    ">
      <div class="company-info-box">
        <img :src="data.logo" alt="" width="56">
        <div class="company-info">
          <p class="company-name">{{data.name}}</p>
          <p class="company-desc"><span v-if="data.company_type">{{data.company_type}}</span><span v-if="data.scale">{{data.scale}}</span></p>
        </div>
      </div>
      <div class="content-box">
        <p class="title-box" v-if="data.stats_tags">公司舆论</p>
        <div class="consensus-tags" v-if="data.stats_tags">
          <div :class="['tag-item', item.status]" v-for="(item, index) in data.stats_tags" :key="index + 'tags'">{{item.name}}</div>
        </div>
        <p class="title-box" v-if="data.stats_from && data.stats_to">公司人才流动（top5）</p>
        <div class="talents-box" v-if="data.stats_from && data.stats_to">
          <div class="talents-box-item">
            <p class="talents-titles">公司人才主要来自以下公司</p>
            <div class="company-school-list">
              <template v-if="data.stats_from">
                <div class="company-item" v-for="item in data.stats_from.slice(0, 5)" :key="item + '222'">
                  <img :src="item.logo_url || 'https://files.wondercv.com/PC/editor/planning/company.png'" alt="">
                  <span>{{item.name}}</span>
                </div>
              </template>
              <div  v-else style="height: 100%;display: flex;align-items: center;justify-content: center;color: #fff;flex-direction: column;">
                <img src="https://files.wondercv.com/PC/editor/planning/company/default.png" alt="" width="74" height="74">
                <p>暂无数据</p>
              </div>
            </div>
          </div>
          <div class="talents-box-item" >
            <p class="talents-titles">公司人才主要去了以下公司</p>
            <div class="company-school-list">
              <template v-if="data.stats_to">
                <div class="company-item" v-for="(item, index) in data.stats_to.slice(0, 5)" :key="index + '222'">
                  <img :src="item.logo_url || 'https://files.wondercv.com/PC/editor/planning/company.png'" alt="">
                  <span>{{item.name}}</span>
                </div>
              </template>
              <div  v-else style="height: 100%;display: flex;align-items: center;justify-content: center;color: #fff;flex-direction: column;">
                <img src="https://files.wondercv.com/PC/editor/planning/company/default.png" alt="" width="74" height="74">
                暂无数据
              </div>
            </div>
          </div>
        </div>
        <p class="title-box" v-if="data.stats_employee_schools && !notPerson">人才教育背景</p>
        <div class="talents-box" v-if="data.stats_employee_schools && !notPerson">
          <div class="talents-box-item">
            <p class="talents-titles" v-if="data.stats_employee_schools">主要毕业院校</p>
            <div class="company-school-list" v-if="data.stats_employee_schools">
              <template v-if="data.stats_employee_schools">
                <div class="company-item" v-for="(item, index) in data.stats_employee_schools.slice(0, 5)" :key="index + '222'">
                  <img :src="item.logo_url" alt="">
                  <span>{{item.name}}</span>
                </div>
              </template>
              <div  v-else style="height: 100%;display: flex;align-items: center;justify-content: center;color: #fff;flex-direction: column;">
                <img src="https://files.wondercv.com/PC/editor/planning/company/default.png" alt="" width="74" height="74">
                暂无数据
              </div>
            </div>
          </div>
          <div class="talents-box-item" v-if="!notPerson">
            <p class="talents-titles">人才学历分布</p>
            <div class="company-school-list" id="person" style="padding: 0">
              <div v-if="notPerson" style="height: 100%;display: flex;align-items: center;justify-content: center;color: #fff;flex-direction: column;">
                <img src="https://files.wondercv.com/PC/editor/planning/company/default.png" alt="" width="74" height="74">
                暂无数据
              </div>
            </div>
          </div>
        </div>
        <p class="title-box" v-if="data.stats_salary">公司薪资分布</p>
        <div v-if="data.stats_salary">
          <div class="salary-title">
            <p>平均薪资：<span>¥{{data.stats_salary ? data.stats_salary.average : '未知'}}</span></p>
            <p>同地区工资水平相比：<span :class="['salary-change', data.stats_salary.compare && data.stats_salary.compare[0] && data.stats_salary.compare[0].status]"><i :class="[data.stats_salary.compare && data.stats_salary.compare[0] && data.stats_salary.compare[0].status === 'up' ? 'iconshangla' : 'iconxiala2', 'iconfont']"></i>{{ data.stats_salary.compare && data.stats_salary.compare[0] && data.stats_salary.compare[0].percent || 0 }}%</span></p>
            <p>同行业工资水平相比：<span :class="['salary-change', data.stats_salary.compare && data.stats_salary.compare[0] && data.stats_salary.compare[0].status]"><i :class="[data.stats_salary.compare && data.stats_salary.compare[0] && data.stats_salary.compare[0].status === 'up' ? 'iconshangla' : 'iconxiala2', 'iconfont']"></i>{{ data.stats_salary.compare && data.stats_salary.compare[1] && data.stats_salary.compare[1].percent || 0 }}%</span></p>
            <div class="salary-chart">

            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="company-info-box">
          <img src="https://files.wondercv.com/PC/editor/planning/company.png" alt="" width="56">
          <div class="company-info">
            <p class="company-name">{{data.name}}</p>
          </div>
        </div>
      <div class="content-box">
        <div class="not-data-box">
          <img src="https://files.wondercv.com/PC/editor/planning/company/default.png" alt="">
          <p>暂无该公司相关信息</p>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  const chart = require('echarts');
  export default {
    name: "experience-detail",
    props: {
      position: [String],
      data: {
        type: Object,
        default: () => ({})
      },
      hasTime: {
        type: Boolean,
        default: true
      }
    },
    data(){
      return{
        notPerson: false
      }
    },
    mounted() {
      this.personChartInit();
      this.salaryChartInit()

    },
    methods: {
      async personChartInit(){
        if(!this.data.stats_employee_degrees) {
          this.notPerson = true
          return;
        }
        let myChart = chart.init(document.querySelector("#person"));
        let data = this.data.stats_employee_degrees.map(item=>({name: item.degree, value: Math.floor(item.percent * 100)}))
        // 绘制图表
        let option ={
          series: [
            {
              type: 'pie',
              radius: '60%',
              data,
              label:{
                color: "rgba(255, 255, 255, 0.6)",
                formatter: '{b}'
              }
            }
          ]
        };
        myChart.setOption(option);
      },
      async salaryChartInit(){
        if(!document.querySelector(".salary-chart"))return ;
        let myChart = chart.init(document.querySelector(".salary-chart"));
        // 绘制图表
        let option = {
          xAxis: {
            type: 'category',
            data: this.data.stats_salary.salary.map(item => item.salary_range),
            axisTick: {
              show: false
            },
            axisLine: {
              show: true
            }
          },
          yAxis: {
            type: 'value',
            splitLine: {
              show: true,
              lineStyle: {
                color: 'rgba(80, 85, 100, 1)',
                type: "dashed"
              }
            },
            axisLine: {
              show: true
            }
          },
          series: [{
            data: this.data.stats_salary.salary.map(item => item.percent),
            type: 'bar',
            barWidth: 12,
            itemStyle: {
              barBorderRadius: 6,
              color: "rgba(255, 255, 255, 0.8)"
            }
          }]
        };
        myChart.setOption(option);
      },
    }
  }
</script>

<style scoped lang="scss">
.experience--detail-box{
  position: absolute;
  width: 630px;
  height: 600px;
  background: #313540;
  box-shadow: 0px 2px 48px 0px rgba(6, 6, 11, 0.5);
  border-radius: 8px;
  top: 51px;
  left: 538px;

  .company-info-box{
    width: 100%;
    height: 96px;
    background: #3D424F;
    border-radius: 8px 8px 0px 0px;
    display: flex;
    align-items: center;
    padding: 20px 24px;
    box-sizing: border-box;
    img{
      margin-right: 16px;
      border-radius: 8px;
    }
    .company-info{
      .company-name{
        font-size: 18px;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 25px;
        margin-bottom: 6px;
      }
      .company-desc{
        display: flex;
        &>span{
          margin-right: 13px;
          position: relative;
          font-size: 14px;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.8);
          line-height: 14px;
          &::after{
            width: 1px;
            content: "";
            height: 9px;
            top: 3px;
            background: #CFCFCF;
            position: absolute;
            right: -6px;
          }
          &:last-child::after{
            width: 1px;
            content: "";
            height: 0px;
          }
        }
      }
    }
  }
  .content-box{
    overflow-y: auto;
    &::-webkit-scrollbar{
      display: none;
    }
    height: 504px;
    padding: 20px 24px 32px;
    box-sizing: border-box;
    .title-box{
      font-size: 14px;
      font-weight: 400;
      color: #FFFFFF;
      line-height: 20px;
      padding-bottom: 8px;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      margin-bottom: 16px;
    }
    .consensus-tags{
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      gap: 8px;
      margin-bottom: 32px;
      .tag-item{
        font-size: 14px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 20px;
        padding: 4px 12px;
        box-sizing: border-box;
        border-radius: 4px;
        border: 1px solid rgba(255, 255, 255, 0.6);
        &.negative{
          border: 1px solid #FF8F69;
          color: #FF8F69;
        }
      }
    }
    .talents-box{
      display: flex;
      justify-content: space-between;
      .talents-box-item{
        width: 283px;
        margin-bottom: 32px;
        .talents-titles{
          font-size: 14px;
          font-weight: 400;
          color: rgba(255, 255, 255, 0.6);
          line-height: 20px;
          text-align: center;
          margin-bottom: 16px;
        }
        .company-school-list{
          width: 283px;
          height: 204px;
          background: #3D424F;
          border-radius: 8px;
          padding: 24px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
          gap: 10px;
          .company-item{
            display: flex;
            align-items: center;
            &>img{
              width: 24px;
              height: 24px;
              border-radius: 3px;
              margin-right: 8px;
            }
            &>span{
              font-size: 14px;
              font-weight: 400;
              color: rgba(255, 255, 255, 0.8);
              line-height: 20px;
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;

            }
          }
          .school-item{
            display: flex;
            align-items: center;
            &>img{
              width: 24px;
              height: 24px;
              margin-right: 8px;
              border-radius: 50%;
            }
            .school-name{
              flex: 1;
              font-size: 14px;
              font-weight: 400;
              color: rgba(255, 255, 255, 0.8);
              overflow: hidden;
              text-overflow:ellipsis;
              white-space: nowrap;
              line-height: 20px;
              margin-right: 32px;
            }
            .proportion{
              font-size: 14px;
              font-weight: 400;
              color: rgba(255, 255, 255, 0.8);
              line-height: 20px;
            }
          }
        }
      }
    }
    .salary-title{
      &>p{
        font-size: 14px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.6);
        line-height: 20px;
        margin-bottom: 6px;
        &>span{
          font-size: 14px;
          font-weight: 500;
          color: #FFFFFF;
          line-height: 20px;
        }
      }
    }
    .salary-change{
      color: rgba(255, 133, 105, 1);
      &.up{
        color: #68E187;
      }
    }
    .salary-chart{
      width: 100%;
      height: 250px;
    }
    .not-data-box{
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      img{
        width: 74px;
        height: 74px;
        margin-bottom: 18px;
      }
      p{
        font-size: 14px;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.8);
        line-height: 14px;
        text-align: center;
      }
    }
  }
}
</style>
